import {AudioExtension} from './types'

// Cloud Storage (file type enforcement) utils
export const audioFileExtensionToContentType = {
  m4a: 'audio/m4a',
  mp4: 'audio/mp4',
  wav: 'audio/wav',
  webm: 'audio/webm',
  weba: 'audio/webm',
  mp3: 'audio/mpeg',
  ogg: 'audio/ogg'
} as const

// This may seem redundant but unfortunately these are not a 1 to 1 mappings
// So this map implicitly holds opinions as to which codecs pair with which extensions
export const contentTypeToAudioFileExtension: {[key: string]: AudioExtension} = {
  'audio/m4a': 'm4a',
  'audio/mp4': 'mp4',
  'audio/wav': 'wav',
  'audio/webm': 'webm',
  'audio/mpeg': 'mp3'
} as const

const audioFileExtensions = Object.keys(audioFileExtensionToContentType)
const audioFileContentTypes = Object.values(audioFileExtensionToContentType)

export const audioFileExtensionsSet = new Set<string | undefined>(audioFileExtensions)
export const audioFileContentTypesSet = new Set<string | undefined>(audioFileContentTypes)

export const nonAudioFileExtensionToContentType = {
  note: 'application/zip',
  ntb: 'application/zip',
  pdf: 'application/pdf',
  image: 'application/octet-stream',
  gif: 'application/octet-stream',
  png: 'application/octet-stream',
  jpg: 'application/octet-stream',
  webp: 'application/octet-stream',
  avif: 'application/octet-stream'
} as const

export const nonAudioFileExtensions = Object.keys(nonAudioFileExtensionToContentType)
export const nonAudioFileContentTypes = Object.values(nonAudioFileExtensionToContentType)

export const nonAudioFileExtensionsSet = new Set<string>(nonAudioFileExtensions)
export const nonAudioFileContentTypesSet = new Set<string>(nonAudioFileContentTypes)

export const fileExtensionToContentType = {
  ...audioFileExtensionToContentType,
  ...nonAudioFileExtensionToContentType
} as const

export const fileExtensionsSet = new Set<string>([...audioFileExtensions, ...nonAudioFileExtensions])
export const fileTypesSet = new Set<string>([...audioFileContentTypes, ...nonAudioFileContentTypes])

export const allFileExtensions = Array.from(fileExtensionsSet)
export const allFileTypes = Array.from(fileTypesSet)
